import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { ContactRequest } from '@services/associations/model/contactRequest';
import { ContactResponse } from '@services/associations/model/contactResponse';
import { PageContactResponse } from '@services/associations/model/pageContactResponse';
import { PaginationModel } from '@shared/models/pagination.model';
import {ContactsFilter} from "@crm/models/ContactsFilter";

export enum ContactsActionTypes {
  LoadContacts = '[Contacts] Load Contacts',
  LoadContactsSuccess = '[Contacts] Load Contacts Success',
  LoadContactsFailure = '[Contacts] Load Contacts Failure',
  AddContact = '[Contacts] Add Contact',
  AddContactSuccess = '[Contacts] Add Contact Success',
  AddContactFailure = '[Contacts] Add Contact Failure',
  EditContact = '[Contacts] Edit Contact',
  EditContactSuccess = '[Contacts] Edit Contact Success',
  EditContactFailure = '[Contacts] Edit Contact Failure',
  DeleteContact = '[Contacts] Delete Contact',
  DeleteContactSuccess = '[Contacts] Delete Contact Success',
  DeleteContactFailure = '[Contacts] Delete Contact Failure',
  ChangePage = '[Contacts] Change Page',
  SetInitialPagination = '[Contacts] Set Initial Pagination',
  SetFilter = '[Contacts] Set Filter',
  ClearFilter = '[Contacts] Clear Filter',
  SetInitialState = '[Contacts] Set Initial State',
}

/** Load Contacts */
export class LoadContacts implements Action {
  readonly type = ContactsActionTypes.LoadContacts;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadContactsSuccess implements Action {
  readonly type = ContactsActionTypes.LoadContactsSuccess;
  constructor(public payload: PageContactResponse) { }
}

export class LoadContactsFailure implements Action {
  readonly type = ContactsActionTypes.LoadContactsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Add Contact */
export class AddContact implements Action {
  readonly type = ContactsActionTypes.AddContact;
  constructor(public payload: ContactRequest) {}
}

export class AddContactSuccess implements Action {
  readonly type = ContactsActionTypes.AddContactSuccess;
  constructor(public payload: ContactResponse, public isSocket?: boolean) { }
}

export class AddContactFailure implements Action {
  readonly type = ContactsActionTypes.AddContactFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Contact */
export class EditContact implements Action {
  readonly type = ContactsActionTypes.EditContact;
  constructor(public payload: {contactId: string, request: ContactRequest}) {}
}

export class EditContactSuccess implements Action {
  readonly type = ContactsActionTypes.EditContactSuccess;
  constructor(public payload: ContactResponse, public isSocket?: boolean) { }
}

export class EditContactFailure implements Action {
  readonly type = ContactsActionTypes.EditContactFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Delete Contact */
export class DeleteContact implements Action {
  readonly type = ContactsActionTypes.DeleteContact;
  constructor(public payload: string) {}
}

export class DeleteContactSuccess implements Action {
  readonly type = ContactsActionTypes.DeleteContactSuccess;
  constructor(public payload: void) { }
}

export class DeleteContactFailure implements Action {
  readonly type = ContactsActionTypes.DeleteContactFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = ContactsActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = ContactsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = ContactsActionTypes.SetFilter;
  constructor(public payload: ContactsFilter) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = ContactsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = ContactsActionTypes.SetInitialState;
}

export type ContactsActions =
  | LoadContacts
  | LoadContactsSuccess
  | LoadContactsFailure
  | AddContact
  | AddContactSuccess
  | AddContactFailure
  | EditContact
  | EditContactSuccess
  | EditContactFailure
  | DeleteContact
  | DeleteContactSuccess
  | DeleteContactFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

